import { render, staticRenderFns } from "./WorkerDetails.vue?vue&type=template&id=0c1083b0&scoped=true&"
import script from "./WorkerDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkerDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerDetails.vue?vue&type=style&index=0&id=0c1083b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1083b0",
  null
  
)

export default component.exports